<template>
    <router-link
        :to="{ name: 'profile', params: {id: card.user.id}}"
        class="morda-lenta-link"
    >
        <div class="morda-lenta-front card-face">
            <div
                :style="{
                    'background-image':
                    card.user.avatar ?
                    'url(' + card.user.avatar + ')' :
                    ''
                }"
                class="morda-lenta-avatar"
                :class="{
                    'no-avatar': !card.user.avatar
                }"
            ></div>
            <CardFace
                :suit="card.suit"
                :rank="ranks[card.rank] || card.rank"
            ></CardFace>                       
        </div>
        <div class="morda-lenta-back card-shirt">
            <span lang="ru">{{ card.text }}</span>
        </div>
    </router-link>
</template>

<script>
    import CardFace from '@/components/Blocks/CardFace';

    export default {
        name: 'mordaLenta',
        components: {
            CardFace
        },
        props:{
            card: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                ranks: {
                    11: 'J',
                    12: 'Q',
                    13: 'K',
                    14: 'A'
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/styles/components/_playing-card';
</style>